module.exports = __webpack_public_path__ + "static/8-35e8fa3888386dec21b27930c70a5694.png";